import React, { useRef } from "react";
import styles from "./FooterNav.module.css";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';

function FooterNav() {
    const dateYear = useRef(new Date().getFullYear()); // Initialize with current year
    const year = dateYear.current;

    return(
        <div className={styles["footer-container"]}>
            <div className={styles["footer-content"]}>
                <p className={styles["copy-right"]}>Copyright © {year} Presage Technologies</p>
                
                <div className={styles["socials"]}>
                    <a 
                        href="https://github.com/Presage-Security" 
                        target="__blank" 
                        rel="noopener noreferrer"
                    >
                        <GitHubIcon className={styles["social-icon"]} />
                    </a>

                    <a 
                        href="https://www.linkedin.com/company/presage-tech/" 
                        target="__blank" 
                        rel="noopener noreferrer"
                    >
                        <LinkedInIcon className={styles["social-icon"]} />
                    </a>

                    <a 
                        href="https://www.twitter.com/presagetech" 
                        target="__blank" 
                        rel="noopener noreferrer"
                    >
                        <XIcon className={styles["social-icon"]} />
                    </a>
                </div>

                <a className={styles["tos"]} href="/tos">Terms of Service</a>
            </div>
        </div>
    )
}

export default FooterNav;